export interface LogRequest {
  level: string
  message: string
  context?: any
}

export function LogRequestToJSON(value: LogRequest): any {
  return {
    level: value.level,
    message: value.message,
    context: value.context ?? undefined
  }
}
